export default __webpack_public_path__ + "static/linkBg7_shadow-ef191abf75ebbe6343354dac33e5fced.png";